import 'react-perfect-scrollbar/dist/css/styles.css'
import React, { useEffect, useState } from 'react'
import { useRoutes } from 'react-router-dom'
import firebase from 'firebase/app'
import { ThemeProvider, CircularProgress } from '@material-ui/core'
import GlobalStyles from './components/GlobalStyles'
import './mixins/chartjs'
import theme from './theme'
import routes from './routes'

const App = () => {
    const [isLoggedIn, setIsLoggedIn] = useState()
    const routing = useRoutes(routes(isLoggedIn))

    useEffect(() => {
        firebase.auth().onAuthStateChanged((user) => {
            if (user) {
                user.getIdTokenResult().then((res) => {
                    if (res.claims.admin) {
                        setIsLoggedIn(true)
                    } else setIsLoggedIn(false)
                })
            } else {
                setIsLoggedIn(false)
            }
        })
    }, [])

    if (isLoggedIn === undefined) {
        return (
            <ThemeProvider theme={theme}>
                <CircularProgress />
            </ThemeProvider>
        )
    }

    return (
        <ThemeProvider theme={theme}>
            <GlobalStyles />
            {routing}
        </ThemeProvider>
    )
}

export default App
